const AOS = require('aos');
const $ = require('jquery');
// const _ = require('lodash');

require('@popperjs/core');
require('bootstrap');
require('slick-carousel');

window.jQuery = $;

$(function () {
  loadAOS();
  initSliders();
  initGoogleMapping();
  containerFix();
  submenuOffset();
  heroOffset();
  headerFix();

  // handler for the resize window event
  $(window).on("resize", function () {
    containerFix();
    headerFix();
  });
  // handler for the scroll window event
  $(window).on("scroll", function () {
    checkWindowScroll();
    uncoverElements();
  });

  eventEntries = document.querySelectorAll('.eventEntry');
  for (eventEntry of eventEntries) {

    eventEntry.addEventListener('click', (ev) => {
      ev.target.parentNode.classList.toggle('show');
    });

  }//for

  // Ninja Forms field change
  setTimeout(function() {
    var clubTitle = $("h1").text();
    $('.signup-form .club-signup').attr('value', clubTitle).trigger('change');
  }, 500);

  // toggle other names
  function otherNames() {
    if ($('#acf-field_669e141a20d0d').prop('checked')) {
      $('.acf-field-664f1a641c9a5').show();
    } else {
      $('.acf-field-664f1a641c9a5').hide();
    }
  };

  $('#acf-field_669e141a20d0d').on('change', function(){
    otherNames();
  });

  otherNames();

  // toggle other school
  function otherSchool() {
    var schoolVal = $('#acf-field_664f1a9e1c9ab').val();

    if (schoolVal == 'other') {
      $('.acf-field-664f2335b9905').show();
    } else {
      $('.acf-field-664f2335b9905').hide();
    }
  };

  $('#acf-field_664f1a9e1c9ab').on('change', function(){
    otherSchool();
  });

  otherSchool();

  // toggle other gender
  function otherGender() {
    var schoolVal = $('#acf-field_664f1a4a1c9a4').val();

    if (schoolVal == 'other') {
      $('.acf-field-66b232dd2ac71').show();
    } else {
      $('.acf-field-66b232dd2ac71').hide();
    }
  };

  $('#acf-field_664f1a4a1c9a4').on('change', function(){
    otherGender();
  });

  otherGender();

  // toggle dietary / disability info
  function disability_dietery_info() {
    if ($('#acf-field_664f1a091c9a2').prop('checked') || $('#acf-field_6659871b27bce').prop('checked')) {
      $('.acf-field-664f1a2c1c9a3').show();
    } else {
      $('.acf-field-664f1a2c1c9a3').hide();
    }
  };

  $('#acf-field_664f1a091c9a2').on('change', function(){
    disability_dietery_info();
  });

  $('#acf-field_6659871b27bce').on('change', function(){
    disability_dietery_info();
  });

  disability_dietery_info();

  // Smooth scroll.
  $('a[href*="#"]')
  .not('[href="#"]')
  .not('[href="#0"]')
  .on("click", function (event) {
    if (
      location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
      location.hostname == this.hostname
    ) {
      var target = $(this.hash);
      var offset = $("header").outerHeight();
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");

      if (target.length) {
        event.preventDefault();
        $("html, body").animate({scrollTop: target.offset().top - offset,},1000);
      }
    }
  });

  // Burger click
  $("#burger").click(function () {
    open = !open;
    toggleMenu(open);
  });

  // Active class.
  $("header .nav [href]").each(function () {
    if (this.href == window.location.href) {
      $(this).addClass("active");
    }
  });

  // Submenu.
  $(".submenu-toggle").on("click", function () {
    var toggle = $(this);
    toggle.toggleClass("open");
    $(this).prev(".parent-item").toggleClass("open");
    var submenu = $(this).next(".submenu");
    submenu.addClass("open");
  });

  $(".back-btn").on("click", function() {
    var currentItem = $(this);
    var submenu = currentItem.closest(".submenu");
    submenu.removeClass("open");
  });

  // Gallery Modal
  $('.galleryImage').on('click', function(){
    var currentSlider = $(this);
    var dataImg = currentSlider.attr('data-img');
    var dataAlt = currentSlider.attr('data-alt');
    $('#galleryModal img').attr('src', dataImg).attr('alt', dataAlt);
    $('#galleryModal').modal('show');
  });

  $.fn.isScrolledIntoView = function () {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
    var elemTop = $(this).offset().top;
    return elemTop <= docViewBottom && elemTop >= docViewTop;
  };

  function headerFix() {
    let header = $("header");
    let headerHeight = $(header).outerHeight();
    var firstSection = $('body').find('section').first();
    $(firstSection).css("margin-top", `${headerHeight}px`);
  }
  
  let pinnedCTA = $(".pinnedCTA");
  if (pinnedCTA) {
    let pinnedCTAHeight = $(pinnedCTA).outerHeight();
    $('body').css("padding-bottom", `${pinnedCTAHeight}px`);
  }

  // Signup event
  if ($('#nf-form-7-cont').length > 0) {
    var eventID = $(".event-id").text();
    
    setTimeout(function() {
      $('#nf-form-7-cont .signup-event').attr('value', eventID).trigger('change');
    }, 500);
  }

  // Club map JS
  $('.club-location').each(function () {
    var dataLocation = $(this).data('location');
    var link = "<a href='http://maps.google.com/maps?q=" + encodeURIComponent(dataLocation) + "' target='_blank'>" + $(this).text() + "</a>";
    $(this).html(link);
  });

  // Logout Button
  if ($('#edit-account').length > 0) {
    $('.acf-form-submit input.button-primary').addClass('btn-black');
  }

  // Account Nan anchor
  $('#anchor-nav-filter').change(function() {
    var selectedValue = $(this).val()
    
    if (selectedValue) {
      window.location.href = selectedValue;
    }
  });

  // People search
  $('.peopleSearch input').on('input', filterPeople);

  function filterPeople() {

    let peopleBoxSet = $(this).attr('data-attribute-set');
    var searchTerm = $('.peopleSearch' + peopleBoxSet + ' input').val().toLowerCase();

    //Go through all hidden FAQs and check to see if we have a match
    $('.peopleBox.peopleBoxSet' + peopleBoxSet).each(function () {
    
      var personTitle = $(this).find('h2').text().toLowerCase();
      
      var matchesSearch = searchTerm === '' || personTitle.includes(searchTerm);

      if (matchesSearch) {
        $(this).removeClass('d-none');
      } else {
        $(this).addClass('d-none');
      }//if
      
    });
      
  }//function

});

/**
 * @description loads the AOS library after a set timeout
 */
let loadAOS = () => {
  setTimeout(() => {
    $("body").addClass("loaded");
    setTimeout(() => {
      AOS.init();
    }, 500);
  }, 1000);
};

/**
 * @description checks the scroll value of the window and adds a class to the header if the window is scrolled
 */
let checkWindowScroll = () => {
  let scroll = $(window).scrollTop();
  if (scroll > 0) {
    $("header").addClass("scroll");
  } else {
    $("header").removeClass("scroll");
  }
};

/**
 * @description function for fixing floating elements or page width elements with content to the conventional bootstrap container sizes
 */
let containerFix = () => {
  if ($(".container-fix").length) {
    let containerWidths = {
      576: 540,
      768: 720,
      992: 960,
      1200: 1140,
      1440: 1380,
    };

    let windowWidth = $(window).width();
    let containerWidth = 0;
    // let containerWidth = $(".container").width() + 32;

    for (const [key, value] of Object.entries(containerWidths)) {
      if (windowWidth >= key) {
        containerWidth = value;
      }
    }

    if (containerWidth == 0) {
      console.error("containerWidth = 0 in Global.js on line: 213");
      return;
    } else {
      containerWidth += 32; // account for the padding on a bs container
    }

    // now calculate the padding for the offset on the content
    var padding = (windowWidth - containerWidth) / 2 + 16;

    if (windowWidth >= 992) {
      $(".container-fix").each(function () {
        if ($(this).hasClass("odd")) {
          $(this).css("padding-right", padding + "px");
        } else if ($(this).hasClass("even")) {
          $(this).css("padding-left", padding + "px");
        }
      });
    } else if (windowWidth >= 576 && windowWidth <= 991) {
      $(".container-fix").each(function () {
        $(this).css("padding-left", padding + "px");
        $(this).css("padding-right", padding + "px");
      });
    } else {
      $(".container-fix").each(function () {
        $(this).css("padding-left", "16px");
        $(this).css("padding-right", "16px");
      });
    }
  }
};

/**
 *  @description affix appropriately css positioned elements (ie position = fixed || absolute) below the header banner
 */
let submenuOffset = () => {
  let headerNavigationStripHeight = $("#headerNavigationStrip").outerHeight();
  let dropdown = $(".submenu");
  let scroll = $(document).scrollTop();
  let topstripHeight = 0;

  if (scroll == 0) {
    dropdown.css("top", headerNavigationStripHeight + "px");
  } else if (scroll < topstripHeight) {
    dropdown.css("top", scroll + headerNavigationStripHeight + "px");
  } else {
    dropdown.css("top", headerNavigationStripHeight + "px");
  }
};

/**
 * @description offset elements labeled with the offset hero class by the height of the header
 */
let heroOffset = () => {
  let hero = $(".offset-hero");
  let header = $("header");

  if (hero.length && header.length) {
    let height = $(header).outerHeight();
    $(hero).css("margin-top", `${height}px`);
  }
};

/**
 * @description reveals hidden page elements
 */
let uncoverElements = () => {
  $(".uncover").each(function () {
    if ($(this).isScrolledIntoView() === true) {
      $(this).addClass("show");
    }
  });
};

/**
 * @description initialise the slick sliders for the page
 */
let initSliders = () => {
  // generic slider example
  // go to - https://kenwheeler.github.io/slick/ - for documentation
  $(".gallerySlider").slick({
    dots: false,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToScroll: 1,
    slidesToShow: 5,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 3,
        }
      },
    ],
  });

  $(".footerImagesSlider").slick({
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToScroll: 1,
    slidesToShow: 4,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 2,
        }
      },
    ],
  });

  $(".eventsSlider").slick({
    dots: true,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 4000,
    slidesToScroll: 1,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 2,
        }
      },
    ],
  });
  
  $(".projectsSlider").slick({
    dots: true,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 4000,
    slidesToScroll: 1,
    slidesToShow: 2,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 2,
        }
      },
    ],
  });

  // slider arrow functionality
  // $('.slick-{arrow-name}.slick-prev').click(function () {
  //   $('.{carousel-name}').slick('slickPrev');
  // });
  // $('.slick-{arrow-name}.slick-next').click(function () {
  //   $('.{carousel-name}').slick('slickNext');
  // });
};

/**
 * @description handles opening and closing of the mobile menu on the site
 *
 * @param {*} open flag indicating whether or not the menu is in an open state
 */
var open = false;
let toggleMenu = (open) => {
  $("#burger").toggleClass("open", open);
  $("#navigation-mobile ul").toggleClass("open", open);
};

/**
 * @description centers the map on the current marker or in the center of all markers present
 *
 * @param {*} map the JSON map object being worked on
 */
let centerMap = (map) => {
  let bounds = new google.maps.LatLngBounds();
  $.each(map.markers, function (i, marker) {
    let latlng = new google.maps.LatLng(
      marker.position.lat(),
      marker.position.lng()
    );
    bounds.extend(latlng);
  });
  if (map.markers.length == 1) {
    map.setCenter(bounds.getCenter());
    map.setZoom(map.zoom);
  } else {
    map.fitBounds(bounds);
  }
};

/**
 * @description adds a new marker to the map being created
 *
 * @param {*} $marker the jQuery HTML marker to be added
 * @param {*} map the JSON map object to be operated on
 */
let addMarker = ($marker, map) => {
  let latlng = new google.maps.LatLng(
    $marker.attr("data-lat"),
    $marker.attr("data-lng")
  );
  let icon = {
    url: "" + $marker.attr("data-icon") + "",
    scaledSize: new google.maps.Size(48, 48),
  };
  let marker = new google.maps.Marker({
    icon: icon,
    map: map,
    position: latlng,
  });
  map.markers.push(marker);
  if ($marker.html()) {
    let infowindow = new google.maps.InfoWindow({
      content: $marker.html(),
    });
    google.maps.event.addListener(marker, "click", function () {
      infowindow.open(map, marker);
    });
  }
};

/**
 * @description creates a new map at the location of the jQuery element passed in
 *
 * @param {*} $el the jQuery element to create a map aroudn
 */
let newMap = ($el) => {
  let $markers = $el.find(".marker");
  let args = {
    center: new google.maps.LatLng(0, 0),
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    styles: [
      {
        featureType: "water",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#d3d3d3",
          },
        ],
      },
      {
        featureType: "transit",
        stylers: [
          {
            color: "#808080",
          },
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#b3b3b3",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#ffffff",
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#ffffff",
          },
          {
            weight: 1.8,
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [
          {
            color: "#d7d7d7",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#ebebeb",
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "geometry",
        stylers: [
          {
            color: "#a7a7a7",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#ffffff",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#ffffff",
          },
        ],
      },
      {
        featureType: "landscape",
        elementType: "geometry.fill",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#efefef",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#696969",
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#737373",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [
          {
            color: "#d6d6d6",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {},
      {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#dadada",
          },
        ],
      },
    ],
    zoom: 12,
  };
  let map = new google.maps.Map($el[0], args);
  map.markers = [];
  $markers.each(function () {
    addMarker($(this), map);
  });
  centerMap(map);
  return map;
};

/**
 * @description convenience function for running all code required to generate a single (or multiple) maps on a page
 */
let initGoogleMapping = () => {
  $(".map").each(function () {
    newMap($(this));
  });
};
